/**
 * © Moustapha HENNAWI - Click and Take off - 2021
 */

/*-------------------------------------------------------------------------------------------*/

import { createSlice } from '@reduxjs/toolkit';

/*-------------------------------------------------------------------------------------------*/

const { reducer, actions } = createSlice({
  name: 'aeros',
  initialState: {
    items: [],
    visited: [],
    runways: [],
    showAll: false
  },
  reducers: {
    initial(state, action) {
      state.items = action.payload;
    },
    update(state, action) {
      action.payload.forEach(
        (item) => (state.items[state.items.findIndex((e) => e.id === item.id)] = item)
      );
    },
    updateVisited(state, action) {
      state.visited = action.payload;
    },
    initialRunways(state, action) {
      state.runways = action.payload;
    },
    updateRunways(state, action) {
      action.payload.forEach(
        (item) => (state.runways[state.runways.findIndex((e) => e.id === item.id)] = item)
      );
    },
    delete(state, action) {
      state.items = state.items.filter((item) => item.id !== action.payload);
    },
    deleteRunways(state, action) {
      state.runways = state.runways.filter((item) => item.id !== action.payload);
    },
    updateShowAll(state, action) {
      state.showAll = action.payload;
    }
  }
});

/*-------------------------------------------------------------------------------------------*/

export { actions as aerosActions };
export { reducer as aerosReducer };

/*-------------------------------------------------------------------------------------------*/
